import { useUi } from "@/store/ui";
import { Dialog } from "@/ui/kit/dialog";
import { Kbd } from "@/ui/kit/kbd";

const SHORTCUTS: [string, string][] = [
  ["Ctrl K", "Command palette"],
  ["Ctrl S", "Save preset"],
  ["Ctrl ⇧ S", "Save as copy"],
  ["Ctrl O", "Open presets"],
  ["Ctrl Z / Ctrl ⇧ Z", "Undo / redo"],
  ["E", "Export"],
  ["\\", "Flip between A and B"],
  ["B", "Pin current state as B"],
  ["I", "Toggle inspect mode"],
  ["Alt + click", "Inspect any preview element"],
  ["Space", "Randomize unlocked swatches"],
  ["G / A", "Generate / Adjust panel"],
  ["1 – 8", "Switch preview"],
  ["?", "This sheet"],
];

export function ShortcutsDialog() {
  const open = useUi((s) => s.dialog === "shortcuts");
  return (
    <Dialog
      open={open}
      onOpenChange={(o) => !o && useUi.getState().openDialog(null)}
      title="Keyboard shortcuts"
      className="w-[min(92vw,460px)]"
    >
      <div className="divide-y divide-line px-5 py-2">
        {SHORTCUTS.map(([keys, what]) => (
          <div key={what} className="flex items-center justify-between py-2 text-sm">
            <span className="text-muted">{what}</span>
            <Kbd className="text-[11px]">{keys}</Kbd>
          </div>
        ))}
      </div>
    </Dialog>
  );
}
